// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardContainer {
  width: 89%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.cardContainer .cardInfo {
  display: flex;
  align-items: center;
}
.cardContainer .cardInfo .cardStats {
  margin-left: 14px;
}
.cardContainer .cardInfo .cardStats h1 {
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
  padding: 0;
}
.cardContainer .cardInfo .cardStats p {
  display: flex;
  align-items: center;
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.cardContainer .profit {
  color: #FFFFFF;
  text-align: right;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/modules/history/historyCard/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AADJ;AAEI;EACI,aAAA;EACA,mBAAA;AAAR;AACQ;EACI,iBAAA;AACZ;AAAY;EACI,cCfH;EDgBG,iCEXP;EFYO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AAEhB;AAAY;EACI,aAAA;EACA,mBAAA;EACA,cC1BC;ED2BD,iCEvBP;EFwBO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AAEhB;AAGI;EACI,cCzCK;ED0CL,iBAAA;EACA,iCEtCC;EFuCD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AADR","sourcesContent":["@import \"../../../scss/fonts.scss\";\n@import \"../../../scss/colors.scss\";\n\n.cardContainer{\n    width: 89%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    .cardInfo{\n        display: flex;\n        align-items: center;\n        .cardStats {\n            margin-left:14px;\n            h1{\n                color: $color-White;\n                font-family: $Roboto;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 24px; \n                margin: 0;\n                padding: 0;\n            }\n            p{\n                display: flex;\n                align-items: center;\n                color:$color-Secondary;\n                font-family: $Roboto;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 16px; /* 133.333% */\n                margin: 0;\n                padding: 0;\n                text-transform: uppercase;\n\n            }\n        }\n    }\n    .profit{\n        color: $color-White;\n        text-align: right;\n        font-family: $Roboto;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        text-transform: uppercase;\n    }\n}","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
